import { combineReducers } from "@reduxjs/toolkit";
import client from "./client"

const rootReducer = combineReducers({
    client,
})

export default rootReducer